export function gdiyEpisodeUrl(guest: string): string | null {
  const slug = guest
    .normalize("NFKD")
    .replace(/\p{M}/gu, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
  if (!slug) return null;
  return `https://www.gdiy.fr/podcast/${slug}/`;
}
